/**
 * Partner portal navigation (frontend spec 2.3): Board and Schedule per partner.
 * They are the icon rail's two entries and the page tabs (prototype PortalBoard
 * F1, FCPortalBoard K1, WarehousePortalBoard WP1).
 */
import { CalendarDays, Columns3 } from "lucide-react";

import type { PortalNavItem } from "@/components/navigation/PortalSidebar";
import { PARTNER_PORTALS, type FlowPartnerKind } from "@/lib/auth/partnerAccess";

export function partnerNav(partner: FlowPartnerKind): PortalNavItem[] {
  const { root } = PARTNER_PORTALS[partner];
  return [
    { key: "board", path: `${root}/board`, label: "Board", icon: Columns3, iconClass: "text-icon-products" },
    { key: "schedule", path: `${root}/schedule`, label: "Schedule", icon: CalendarDays, iconClass: "text-icon-tasks" },
  ];
}
